import { stringToBoolean } from "./utils"

const flags = [
    { name: "temporaryUnavailable", isActive: stringToBoolean(window._env_?.TEMPORARY_UNAVAILABLE) },
    { name: "entrantFormEnabled", isActive: stringToBoolean(window._env_?.ENTRANT_FORM_ENABLED) },
    { name: "entrantSurveyEnabled", isActive: stringToBoolean(window._env_?.ENTRANT_SURVEY_ENABLED) },
    { name: "entrantApplicationsEnabled", isActive: stringToBoolean(window._env_?.ENTRANT_APPLICATIONS_ENABLED) },
]

export default flags